(function() {
  var FREE_SHIPPING_THRESHOLD = 69900;

  function updateShippingBar() {
    var bar = document.querySelector('.pf-cart__shipping-bar-fill');
    var text = document.querySelector('.pf-cart__shipping-amount');
    var msgFree = document.querySelector('.pf-cart__shipping-free');
    var msgNeeded = document.querySelector('.pf-cart__shipping-needed');
    if (!bar) return;

    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var total = cart.total_price;
        var pct = Math.min((total / FREE_SHIPPING_THRESHOLD) * 100, 100);
        bar.style.width = pct + '%';
        if (total >= FREE_SHIPPING_THRESHOLD) {
          bar.classList.add('pf-cart__shipping-bar-fill--done');
          if (msgFree) msgFree.style.display = 'block';
          if (msgNeeded) msgNeeded.style.display = 'none';
        } else {
          bar.classList.remove('pf-cart__shipping-bar-fill--done');
          var remaining = ((FREE_SHIPPING_THRESHOLD - total) / 100).toFixed(0);
          if (text) text.textContent = 'S/ ' + remaining;
          if (msgFree) msgFree.style.display = 'none';
          if (msgNeeded) msgNeeded.style.display = 'block';
        }
      }).catch(function() {});
  }

  function initDiscountField() {
    var btn = document.querySelector('.pf-cart__discount-apply');
    if (!btn || btn._pfInit) return;
    btn._pfInit = true;
    btn.addEventListener('click', function() {
      var input = document.querySelector('.pf-cart__discount-input');
      var msg = document.querySelector('.pf-cart__discount-msg');
      if (!input || !input.value.trim()) return;
      var code = input.value.trim().toUpperCase();
      btn.textContent = '...';
      btn.disabled = true;
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { discount_code: code } })
      }).then(function() {
        if (msg) { msg.textContent = '\u2714 C\u00f3digo aplicado'; msg.className = 'pf-cart__discount-msg pf-cart__discount-msg--ok'; }
        btn.textContent = 'Aplicar'; btn.disabled = false;
      }).catch(function() {
        if (msg) { msg.textContent = 'C\u00f3digo inv\u00e1lido'; msg.className = 'pf-cart__discount-msg pf-cart__discount-msg--err'; }
        btn.textContent = 'Aplicar'; btn.disabled = false;
      });
    });
  }

  function initUpsellButtons() {
    if (document._pfUpsellInit) return;
    document._pfUpsellInit = true;
    document.addEventListener('click', function(e) {
      var btn = e.target.closest('.pf-cart__upsell-btn');
      if (!btn) return;
      var variantId = btn.dataset.variantId;
      if (!variantId) return;
      btn.textContent = '...';
      btn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      }).then(function(r) { return r.json(); }).then(function() {
        btn.textContent = '\u2714 Agregado';
        btn.classList.add('pf-cart__upsell-btn--added');
        updateShippingBar();
      }).catch(function() { btn.textContent = '+ Agregar'; btn.disabled = false; });
    });
  }

  function init() {
    updateShippingBar();
    initDiscountField();
    initUpsellButtons();
    document.addEventListener('cart:updated', updateShippingBar);
    document.addEventListener('cart-updated', updateShippingBar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }

  var observer = new MutationObserver(function() {
    updateShippingBar();
    initDiscountField();
  });
  var drawerEl = document.querySelector('cart-drawer-component');
  if (drawerEl) observer.observe(drawerEl, { childList: true, subtree: true });
})();